/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AgentHostWorktree
 */
export interface AgentHostWorktree {
  /**
   *
   * @type {string}
   * @memberof AgentHostWorktree
   */
  convId: string;
  /**
   *
   * @type {number}
   * @memberof AgentHostWorktree
   */
  sizeBytes?: number | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgentHostWorktree
   */
  sizeComputedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof AgentHostWorktree
   */
  kind?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgentHostWorktree
   */
  lastActiveAt?: OffsetDateTime | null;
  /**
   *
   * @type {boolean}
   * @memberof AgentHostWorktree
   */
  orphan: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgentHostWorktree
   */
  previewActive: boolean;
}

/**
 * Check if a given object implements the AgentHostWorktree interface.
 */
export function instanceOfAgentHostWorktree(
  value: object,
): value is AgentHostWorktree {
  if (!("convId" in value) || value["convId"] === undefined) return false;
  if (!("orphan" in value) || value["orphan"] === undefined) return false;
  if (!("previewActive" in value) || value["previewActive"] === undefined)
    return false;
  return true;
}

export function AgentHostWorktreeFromJSON(json: any): AgentHostWorktree {
  return AgentHostWorktreeFromJSONTyped(json, false);
}

export function AgentHostWorktreeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AgentHostWorktree {
  if (json == null) {
    return json;
  }
  return {
    convId: json["convId"],
    sizeBytes: json["sizeBytes"] == null ? undefined : json["sizeBytes"],
    sizeComputedAt:
      json["sizeComputedAt"] == null ? undefined : json["sizeComputedAt"],
    kind: json["kind"] == null ? undefined : json["kind"],
    lastActiveAt:
      json["lastActiveAt"] == null ? undefined : json["lastActiveAt"],
    orphan: json["orphan"],
    previewActive: json["previewActive"],
  };
}

export function AgentHostWorktreeToJSON(json: any): AgentHostWorktree {
  return AgentHostWorktreeToJSONTyped(json, false);
}

export function AgentHostWorktreeToJSONTyped(
  value?: AgentHostWorktree | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    convId: value["convId"],
    sizeBytes: value["sizeBytes"],
    sizeComputedAt: value["sizeComputedAt"],
    kind: value["kind"],
    lastActiveAt: value["lastActiveAt"],
    orphan: value["orphan"],
    previewActive: value["previewActive"],
  };
}
